import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    width: 250px;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: yellowgreen;
    color: red;
    font-size: 16px;
    user-select: none;
    cursor: wait;
`;

const Circle = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: block;
    border-radius: 50%;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
    box-sizing: border-box;
`;

const Ray = styled.span`
    position: absolute;
    width: 50%;
    height: 2px; /* уменьшаем толщину линии */
    top: 50%;
    left: 50%;
    transform-origin: center center; /* Центр вращения смещаем в середину */
    background-color: blue;
    opacity: 0.5;
    animation: rayRotate 1.5s cubic-bezier(.4,.0,.2,1) infinite both;

    &:nth-child(even) {
        transform: rotate(${({ index }) => `${index * 45}deg`});
    }

    &:nth-child(odd) {
        transform: rotate(${({ index }) => `${index * 45}deg`}); /* одинаковые углы вращения */
    }

    @keyframes rayRotate {
        0% {
            transform: rotate(${({ index }) => `${index * 45}deg`});
        }
        100% {
            transform: rotate(${({ index }) => `${(index + 1) * 45}deg`});
        }
    }
`;

export default function LoadingMagic() {
    return <Container>
        <Circle>
            {[...Array(8)].map((_, idx) => (
                <Ray key={`ray-${idx}`} index={idx}><></></Ray>
            ))}
        </Circle>
    </Container>
}